<template>
	<div class="header-wrap">
		<div class="header">
			<div class="header-l">
				<a href="https://www.kylinos.cn" target="_blank" title="麒麟软件 "><img class="logo" src="@/assets/logo.png"/></a>
				<navTopMain v-if="$route.meta.isShowHeader"/>
				<navTopProduct v-else/>
			</div>
			<div class="header-r" :class="{'guest': !userId}">
				<div class="nav-search">
					<el-input placeholder="请输入内容" v-model="keyWords" @change="toSearch" suffix-icon="el-icon-search"></el-input>
				</div>
				<span v-if="!userId" @click="toLogin" class="public-btn btn-login">登录</span>

				<el-dropdown @command="toPublic" v-if="userId">
					<span v-if="userId" class="public-btn btn-fb">发布</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="article">文章</el-dropdown-item>
						<el-dropdown-item command="video" >视频</el-dropdown-item>
						<el-dropdown-item command="trends" >动态</el-dropdown-item>
						<el-dropdown-item command="optimize">优化建议</el-dropdown-item>
						<el-dropdown-item command="question" >提问</el-dropdown-item>
						<el-dropdown-item command="bug" >Bug反馈</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dropdown @command="toMessage" v-if="userId" @visible-change="getNumber">
					<img class="message-icon" :src="unReadCount && unReadCount !=0 ? require('@/assets/new_message_icon.svg') : require('@/assets/message_icon.svg')"/>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="1" class="box-position">评论与回复<span v-if="numberComment && numberComment != 0" class="box-circle">{{numberComment}}</span></el-dropdown-item>
						<el-dropdown-item command="2" class="box-position">系统消息<span v-if="numberSyetem && numberSyetem != 0" class="box-circle">{{numberSyetem}}</span></el-dropdown-item>
						<el-dropdown-item command="3" class="box-position" >点赞&关注<span v-if="numberLike && numberLike != 0" class="box-circle">{{numberLike}}</span></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<el-dropdown @command="toExitLogin" v-if="userId">
					<span class="el-dropdown-link">
						<router-link v-if="userId" :to="{path: '/publicManage'}"><img class="avatar-icon" :src="userInfo.headPic?userInfo.headPic:require('@/assets/default-avatar.png')"/></router-link>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item >退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>
		<el-dialog style="z-index: 9999999;" title="发表动态" :visible.sync="feedDialog" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
			<div class="dialog-wrap">
				<PublicTrends @toCancel="toCancel"/>
			</div>
		</el-dialog>
		<!-- 优化建议 -->
		<el-dialog style="z-index: 9999999;" title="发布建议" :visible.sync="feedDialogoptimize" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
			<div class="dialog-wrap">
				<PublicQuestion :postType = "3" @toCancel="feedDialogoptimize = false"/>
			</div>
		</el-dialog>
		<!-- 问答 -->
		<el-dialog style="z-index: 9999999;" title="发布问题" :visible.sync="feedDialogQuestion" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
			<div class="dialog-wrap">
				<PublicQuestion :postType = "4" @toCancel="feedDialogQuestion = false"/>
			</div>
		</el-dialog>
		<!-- bug反馈 -->
		<el-dialog style="z-index: 9999999;" title="发布Bug反馈" :visible.sync="feedDialogBug" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
			<div class="dialog-wrap">
				<PublicBug :postType = "5" @toCancel="feedDialogBug = false"/>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
		post,
		ajaxParam
	} from '@/units/request.js'
	import qs from 'qs'
	import navTopMain from '@/components/navTop'
	import navTopProduct from '@/components/product/navTop'
	import PublicTrends from '@/components/public/publicTrends'
	import PublicQuestion from '@/components/public/publicQuestion'
	import PublicBug from '@/components/public/publicBug'
	
	export default {
		name: 'home',
		data(){
			return {

				keyWords: '',
				userId: '',
				userInfo: {},
				feedDialog: false,
				feedDialogoptimize: false,
				feedDialogQuestion: false,
				feedDialogBug: false,
				numberComment: 0,
				numberSyetem: 0,
				numberLike: 0,
				unReadCount: 0
			}
		},
		components: {
			navTopMain,
			navTopProduct,
			PublicTrends,
			PublicQuestion,
			PublicBug
		},
		watch: {
			$route(to, from) {	
				this.userId = localStorage.getItem('uuid') || ''
			}
		},
		mounted() {
			this.userId = localStorage.getItem('uuid') || ''
			this.getUserInfo()
			this.getNumber()
			this.bus.$on('resfreshheaPic',this.getUserInfo)
			this.bus.$on('resfreshheaNum',this.getNumber)
		},
		beforeDestroy(){
			this.bus.$off('resfreshheaPic')
		},
		methods: {
			async getNumber() {
				let param = {
					userId: localStorage.getItem('userId')||''
				}
				ajaxParam(param)
				const res = await post('v1/message/getMessageUnreadCount', qs.stringify(param))
				if(res.data.code==200){
					let obj = res.data.entity
					this.numberComment = Number(obj.replyCount)
					this.numberSyetem = Number(obj.systemCount)
					this.numberLike = Number(obj.likeCount)
					this.unReadCount = Number(obj.unReadCount)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			async getUserInfo() {
				const userId = localStorage.getItem('userId') || ''
				let url = 'v1/user/getUserDetail'
				let param = {
					userId: userId,
					token: localStorage.getItem('token'),
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if (res.data.code == 200) {
					console.log(res)
					this.$set(this,'userInfo',res.data.entity)
				}
			},
			//顶部搜索
			toSearch(){
				if (!this.keyWords.trim()) return
				if (this.$route.query.searchValue != this.keyWords) {
					this.$router.push({
						path: '/circleIndexSearch',
						query: {searchValue: this.keyWords}
					});
				}
			},

			//跳转到消息中心
			toMessage(e){
				let path = ''
				if(e==1) {
					path = '/commentReply'
				} else if(e==2) {
					path = '/systemMessage'
				} else {
					path = '/likeFllow'
				}
				this.$router.push({
					path: path
				})
			},
			//跳转到发布
			toPublic(e){
				console.log(e)
				let path = this.userId?'/public':'/login'
				if(e=='trends') {
				// 动态
					this.feedDialog = true
				}else if(e=='optimize') {
					// 优化建议
					this.feedDialogoptimize = true
				} else if(e=='question') {
				// 问题 
					this.feedDialogQuestion = true
				} else if(e=='bug') {
				// bug反馈 
					this.feedDialogBug = true
				} else {
					this.$router.push({
						path: path,
						query: {
							type: e
						}
					})
				}
			},
			//去登录
			toLogin(){
				this.$router.push({
					path: '/login'
				})
			},
			toExitLogin(){
				this.$confirm('确定要退出登录？','温馨提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
				}).then(async()=>{
					// 获取麒麟ID的access_token（不是论坛JWT token）
					let kylinAccessToken = ''
					try {
						const userStr = localStorage.getItem('user')
						if (userStr) {
							const userObj = JSON.parse(userStr)
							kylinAccessToken = userObj.accessToken || ''
						}
					} catch(e) {
						console.log('解析user失败', e)
					}
					if (kylinAccessToken) {
						try{
							const param = {
								accessToken: kylinAccessToken
							}
							ajaxParam(param)
							const res = await Promise.race([
								post('v1/user/outLogin', qs.stringify(param)),
								new Promise((_, reject) => setTimeout(() => reject(new Error('timeout')), 3000))
							])
							if (res.data && res.data.code != 200) {
								console.log("outLogin 返回非200:", res.data)
							}
						}catch(e){
							console.log("extlogin error", e)
						}
					}
					this.$message.info('退出登录成功!')
					localStorage.removeItem('user')
					localStorage.removeItem('userId')
					localStorage.removeItem('uuid')
					localStorage.removeItem('token')
					localStorage.removeItem('isVisible')
				this.userId = ''
					this.userInfo = {}
					this.$router.push('/home')
				}).catch(()=>{

				})
			},
			toCancel(){
				this.feedDialog = false
			}
		}
	}
</script>

<style scoped lang="less">
	.header-wrap{
		background: rgba(0,0,0,0.8);
		backdrop-filter: blur(10px);
		-webkit-backdrop-filter: blur(10px);
		box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		z-index: 999;
		height: 88px;
	}
	.header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		max-width: 1440px;
		margin: 0 auto;
		box-sizing: border-box;
		position: relative;
		height: 100%;
		padding: 18px 0;
		.header-l{
			display: flex;
			align-items: center;
			gap: 48px;
		}
		.logo{
			width: 86px;
			height: 52px;
		}
		.header-r{
			display: flex;
			align-items: center;
			gap: 24px;
			&.guest{
				gap: 24px;
			}
			.nav-search{
				width: 170px;
				/deep/ .el-input__inner {
					height: 36px;
					line-height: 36px;
					background: rgba(255,255,255,0.1);
					border-radius: 18px;
					border: none;
					color: rgba(255,255,255,1);
					font-size: 14px;
					padding: 0 16px;
				}
				/deep/ .el-input__inner::placeholder{
					color: #86909C;
				}
				/deep/ .el-input__suffix{
					right: 10px;
				}
				/deep/ .el-input__icon{
					color: rgba(255,255,255,0.6);
					line-height: 36px;
				}
			}
			.message-icon{
				width: 24px;
				height: 24px;
				cursor: pointer;
				transition: opacity 0.25s ease;
				&:hover{
					opacity: 0.8;
				}
			}
			.public-btn{
				display: flex;
				justify-content: center;
				align-items: center;
				color: #DD0515;
				cursor: pointer;
				&.btn-login{
					color: #fff;
					font-size: 18px;
					line-height: 28px;
					padding: 8px 24px;
					border-radius: 19px;
					transition: background 0.2s ease;
					&:hover{
						background: rgba(255,255,255,0.1);
					}
				}
				&.btn-fb{
					background: #DD0515;
					border-radius: 18px;
					color: #fff;
					font-size: 14px;
					height: 36px;
					line-height: 36px;
					padding: 0 16px;
				}
			}
			.avatar-icon{
				width: 38px;
				height: 38px;
				border-radius: 50%;
			}
		}
	}
	@media (max-width: 1440px) {
	    .header {
	        max-width: 1200px;
	    }
	}
	@media (max-width: 1280px) {
		.header {
		    max-width: 97%;
		}
	}
	.icon-circle{
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: #DD0515;
		position: absolute;
		right: 0;
		top: 0;
	}
	.box-circle{
		display: inline-block;
		font-size: 12px;
		background: var(--color-text-a);
		position: absolute;
		width: 16px;;
		height: 16px;
		line-height: 16px;
		right: 5px;
		top:50%;
		margin-top: -9px;
		text-align: center;
		border-radius: 50%;
		color: #fff;
	}
	.box-position{
		position: relative;
	}
</style>
